module.exports = __webpack_public_path__ + "media/images/lb/165-c4aef8bfd9f9135c1112f02653d413e7.svg";